<script setup lang="ts">
import type { StateMachineState } from "@shopware-pwa/types";
import { computed } from "vue";
import { Tag } from "~/components/clarity-ui/Tag";

export interface AccountOrderStateLabelProps {
  state: StateMachineState;
}

const { state } = defineProps<AccountOrderStateLabelProps>();

const tagColor = computed(() => {
  if (state?.technicalName.includes("cancel")) {
    return "cancel";
  }
  if (state?.technicalName === "completed") {
    return "cancel";
  }

  return "information";
});
</script>

<template>
  <Tag v-if="state?.name" :color="tagColor" size="small" outlined>{{ state?.name }}</Tag>
</template>
